import { Link } from 'react-router-dom';

export function NotFoundRoute() {
  return (
    <section className="placeholder">
      <h1>Not here</h1>
      <p>
        <Link to="/plan">Back to the board</Link>
      </p>
    </section>
  );
}
